import MathUtility from '../Utility/MathUtility';

export default class Angletool {

	constructor() {
		this.calcType = 'article';
		this.container = document.getElementById('angletool');
		this.resultsContainer = document.getElementById('angle-results-container');
		this.inputs = [].slice.call(document.getElementsByClassName('angletool-input')).reduce((acc, input) => {
			acc[input.name] = input;
			return acc;
		}, []);
		this.flexibleCalcToggle = document.getElementById('flexible-calculation-toggle');
		this.articleCalcToggle = document.getElementById('article-calculation-toggle');

		this.angleResultOutput = document.getElementById('result-angle');
		this.floodheightResultOutput = document.getElementById('result-floodheight');
		this.articlenrResultOutput = document.getElementById('result-articlenr');
		this.chokesizeResultOutput = document.getElementById('result-chokesize');

		this.canvas = document.getElementById('angle-visualization');
		this.canvasbgimage = new Image(576, 577);
		this.canvasbgimage.src = document.getElementById('angle-visualization').dataset.image;

		const inputCollection = document.getElementsByClassName('angletool-input');
		for (let i in inputCollection) {
			if (Object.hasOwn(inputCollection, i)) {
				/* input event is needed for select fields or when the user pastes a value */
				inputCollection[i].addEventListener('input', () => {
					this.validateInputs();
				});
				inputCollection[i].addEventListener('keyup', () => {
					this.validateInputs();
				});
			}
		}

		this.flexibleCalcToggle.addEventListener('click', () => {
			this.container.classList.remove('article-calculation');
			this.container.classList.add('flexible-calculation');
			this.calcType = 'flexible';
			this.validateInputs();
		});
		this.articleCalcToggle.addEventListener('click', () => {
			this.container.classList.remove('flexible-calculation');
			this.container.classList.add('article-calculation');
			this.calcType = 'article';
			this.validateInputs();
		});
	}

	triggerCalculation() {
		let discharge = this.getDischargeValue();

		if (this.calcType === 'article') {
			const articleUid = parseInt(this.inputs.article.value);
			if (!isNaN(discharge) && articleUid > 0) {
				const article = angletooldata['articles'][articleUid],
					choke = angletooldata['chokes'][article['choke']];

				this.calculateAngle(discharge, article, choke);
			} else {
				this.hideResults();
			}
		} else if (this.calcType === 'flexible') {
			let chokeUid = parseInt(this.inputs.chokesize.value),
				floodHeight = this.getFloodHeightValue();

			if (!isNaN(discharge) && chokeUid > 0 && !isNaN(floodHeight)) {
				const choke = angletooldata['chokes'][chokeUid];

				this.calculateAngle(discharge, null, choke, floodHeight);
			} else {
				this.hideResults();
			}
		}
	}

	validateInputs() {
		/* clear results, we only want results if everything is valid */
		this.hideResults();

		let valid = true;
		this.inputs.discharge.classList.remove('angletool-error');
		this.inputs.floodheight.classList.remove('angletool-error');
		let discharge = this.getDischargeValue();
		if (isNaN(discharge) || discharge < 0.05 || discharge > 70) {
			this.inputs.discharge.classList.add('angletool-error');
			valid = false;
		}
		if (this.calcType === 'flexible') {
			let floodHeight = this.getFloodHeightValue();
			if (isNaN(floodHeight) || floodHeight > 3) {
				this.inputs.floodheight.classList.add('angletool-error');
				valid = false;
			}
		}

		if (valid) {
			this.triggerCalculation();
		}
	}

	getDischargeValue() {
		/* limit input to 2 decimal places */
		let discharge = this.inputs.discharge.value;
		const delimiters = ['.', ','];
		delimiters.forEach((delimiter) => {
			if (discharge.indexOf(delimiter) >= 0) {
				this.inputs.discharge.value = discharge.slice(0, discharge.indexOf(delimiter) + 3);
			}
		});

		let dischargeFloat = MathUtility.round(parseFloat(this.inputs.discharge.value.replace(',', '.')), 2);

		if (!isNaN(dischargeFloat)) {
			return dischargeFloat;
		}

		return NaN;
	}

	getFloodHeightValue() {
		/* limit input to 2 decimal places */
		let floodHeight = this.inputs.floodheight.value;
		const delimiters = ['.', ','];
		delimiters.forEach((delimiter) => {
			if (floodHeight.indexOf(delimiter) >= 0) {
				this.inputs.floodheight.value = floodHeight.slice(0, floodHeight.indexOf(delimiter) + 3);
			}
		});

		let floodHeightFloat = MathUtility.round(parseFloat(this.inputs.floodheight.value.replace(',', '.')), 2);

		if (!isNaN(floodHeightFloat)) {
			return floodHeightFloat;
		}

		return NaN;
	}

	calculateAngle(qMax, article, choke, floodHeight = 0) {
		// correction factor, multiply all values by this factor to circumvent floating point precision errors
		const G = 9.81,
			U = 0.6;

		if (article) {
			floodHeight = article.floodHeight;
			this.articlenrResultOutput.innerText = article.nr;
			this.chokesizeResultOutput.innerText = choke.n;
		}

		let v1 = Math.sqrt(2 * G * floodHeight) * U,
			area = (qMax / 1000) / v1,
			angleTmp = Math.pow(choke.r, 2) - Math.pow(choke.ws, 2),
			angle = (area * 360) / (Math.PI * angleTmp);

		if (angle > 180.5) {
			this.resultsContainer.classList.remove('hidden');
			this.resultsContainer.classList.add('angle-error');
			this.resultsContainer.classList.add('error-large');
			return;
		}
		if (angle < 9.5) {
			this.resultsContainer.classList.remove('hidden');
			this.resultsContainer.classList.add('angle-error');
			this.resultsContainer.classList.add('error-small');
			return;
		}
		this.resultsContainer.classList.remove('angle-error', 'error-small', 'error-large');

		this.angleResultOutput.innerText = MathUtility.round(angle, 0);
		this.floodheightResultOutput.innerText = MathUtility.round(floodHeight, 2).toLocaleString();

		this.drawVisualization(angle);
		this.resultsContainer.classList.remove('hidden');
	}

	hideResults() {
		this.resultsContainer.classList.add('hidden');
	}

	drawVisualization(angle) {
		const ctx = this.canvas.getContext('2d'),
			length = 270,
			x0 = Math.round(this.canvas.width / 2),
			y0 = Math.round(this.canvas.height / 2),
			x1 = x0 + length,
			y1 = y0,
			alpha = angle * (Math.PI / 180),
			x2 = x0 + length * Math.cos(alpha),
			y2 = y0 - length * Math.sin(alpha);

		ctx.reset();
		ctx.drawImage(this.canvasbgimage, 0, 0, this.canvas.width, this.canvas.height);

		ctx.strokeStyle = "red";
		ctx.beginPath();
		ctx.moveTo(x0, y0);
		ctx.lineTo(x1, y1);
		ctx.stroke();

		ctx.beginPath();
		ctx.moveTo(x0, y0);
		ctx.lineTo(x2, y2);
		ctx.stroke();
	}
}
